<template>
  <div>
    <div class="row">
      <div class="col-lg-12" v-if="languages.length > 1">
        <div class="dropdown">
          <button class="btn btn-secondary border border-1 border-gray-300 dropdown-toggle float-end mt-1 mx-5" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            {{this.selectedLanguage.title }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li v-for="lang in languages"  :key="lang.title"><a class="dropdown-item" href="#" @click="onSelectedLanguage(lang.code,lang.title)">{{ lang.title }}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content flex-row-fluid p-5" id="help_page">
      <div class="row" v-for="group in groupList" v-bind:key="group">
        <div class="d-flex flex-column flex-row-auto" v-for="rd in group.items" v-bind:key="rd" :class="[rd.pages_content_width]">
          <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6"  v-if="rd.pages_content_is_active != 0" >
            <div class="card-body pt-3 pb-3" > 
              <div class="row">
                <div v-html="rd.pages_content_content" ></div>
              </div>                
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script> 
import axios from 'axios';

  export default {

    name: "HelpPage",
    data() {
      return {
          lists: [],
          searchbar: '',
          menu_selection: '',
          pagesAllLists:[],
          groupList :[],
          pageUrl :  window.location.pathname,
          notPage:0,
          filteredLang:[],
          selectedLanguage:[],
          languages: [],
          getLocalLanguage : localStorage.getItem("locale")
      };
    },
    methods: {
      getData(type){    
        this.$Progress.start();
        this.pagesAllLists = [];
        this.pagesAllLists = [];
        this.groupList = [];
        const parameters = {
          session_id: this.$getUser().session_id,
          menu_selection: this.pageUrl,
          language: this.selectedLanguage.code
        };  
        axios.post('api/HelpPage/GetPageContents', parameters, {'Content-Type': 'application/json'})
        .then((response) => { 
          this.pagesAllLists = response.data.contents;
          this.languages = response.data.language;
          if (type === 1 && this.languages.length > 0) {
            const defaultLang = this.languages.find( l => l.code == this.getLocalLanguage);
            if (defaultLang) {
               this.selectedLanguage = {
                code: defaultLang.code,
                title: defaultLang.title
              };
              this.onSelectedLanguage(defaultLang.code,defaultLang.title);

            }else{
              this.selectedLanguage = {
                code: this.languages[0].code,
                title: this.languages[0].title
              };
              this.onSelectedLanguage(this.languages[0].code,this.languages[0].title);

            }
          }
          this.pagesAllLists.forEach((item) => { 
              if(!this.groupList.find(existingKey => existingKey.key == item.pages_content_is_group )) {
                this.groupList.push({key: item.pages_content_is_group , items: []});                   
              } 
            });
            response.data.contents.forEach((rd) => { 
              this.groupList.forEach((gl) => {
                if( gl.key == rd.pages_content_is_group ){
                  gl.items.push(rd);
                }    
              }); 
            });
            sessionStorage.clear();
            this.$Progress.finish();
          })
          .catch((error) => {
            console.error(error);
            sessionStorage.clear();
            this.$Progress.finish();
          });  
      },
      onSelectedLanguage(selectLang,selectTitle){
        this.selectedLanguage.code = selectLang;
        this.selectedLanguage.title = selectTitle;
        this.getData();
      },
    }, 
    mounted() {
       this.getData(1);
    },
  }; 
</script>
<style scoped>
a:link {
  text-decoration: none;
  font-size: large;
  cursor: pointer;
}
a:hover {
  text-decoration: underline;
}
</style>